import styled from 'styled-components';
import {
  Checkbox as SemanticCheckbox,
} from 'semantic-ui-react';

export const RadioBox = styled(SemanticCheckbox)`
  &.customBackground {
    &.ui.radio.checkbox input:checked ~ .box:before,
    &.ui.radio.checkbox label:before {
      background-color: rgba(255,63,63,0.5);
      border-color: red;
    }
  }
`;

export const MatrixTableContainer = styled.div`
  overflow:auto;
  width: 100%;
  min-height: auto;
  max-height: 400px;

`;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TableRow = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
`;

export const TableCell = styled.div`
  min-width: 120px;
  max-width: 120px;
  color: ${(props) => (props.theme.color.textSecondary)};
  align-items: center;
  justify-content: center;
  text-align: ${(props) => (props.row ? 'left' : 'center')};
`;
